<template>
	<div class="col" gutter="15">
		<span class="title">{{ title }}</span>
		<div>
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	props: ['title'],
	data() {
		return {}
	}
}
</script>

<style lang="scss" scoped>
.title {
	display: flex;
	align-items: center;
	white-space: nowrap;

	&::after {
		content: "";
		flex: 1;
		height: 0;
		border-top: 2px dashed #c0c4cc;
		margin-left: 15px;
	}
}
</style>